import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function NamKhao() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Nam Khao</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>
        <b>Nam Khao</b>
        <br></br>
        2.5 cups cooked rice<br></br>2 tbsp Thai red curry paste<br></br>2
        cloves garlic<br></br>1 shallot<br></br>3 lime leaves<br></br>3 tsp
        sugar<br></br>3 tsp light soy sauce<br></br>1 Lettuce<br></br>
        <b>Dressing</b>
        <br></br>2 tbsp light soy sauce<br></br>1 chili<br></br>2 cloves garlic
        <br></br>
        1/2 lime juice<br></br>
        2tbsp sugar<br></br>
        1/4 cup water<br></br>
      </Typography>

      <Typography>
        Mix the rice, curry paste, 2 cloves of garlic, shallot, lime leaves,
        sugar, and soy sauce together into small balls.<br></br>
        Shallow fry until crispy.<br></br>
        <br></br>
        Mix the remaining dressing ingredients together, and combine with the
        rice.<br></br>
        <br></br>
        Serve in lettuce wraps.<br></br>
      </Typography>
    </Card>
  );
}
